import CryptoJS from 'crypto-js';
const cryptoKey = 'JodHRwczovL2lkZW50aXR5dG9vbGtpdC5nb29nbGVhcGlzLmNvbS9nb29nbGUuaWRlbnRpdHkuaW';

export default {
  encrypt(word) {
    return CryptoJS.AES.encrypt(word, cryptoKey).toString();
  },  
  decrypt(word) {
    return CryptoJS.AES.decrypt(word, cryptoKey).toString(CryptoJS.enc.Utf8);
  },
}